






import { AuthStoreHelper, RootStoreHelper } from '../../core/mixins';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChatbotConversationStatusEnum, ChatConversationStatus } from '../models/ChatConstants';
import { ID } from '../../core/utils';
import { getConversationStatus } from '../utils';
@Component({
    components: {
     
    }
})
export default class ChatbotConversationStatusIndicator extends Mixins(RootStoreHelper, AuthStoreHelper) {
    @Prop({default: -1}) conversationId: ID



    get getCurrentConversationStatus(){
      return getConversationStatus(this.conversationId, this.$_getChatbotConversations)
    }

    get getLabelForCurrentConversationStatus(){
      switch(this.getCurrentConversationStatus) {
        case ChatConversationStatus.DISABLED:
          return ChatbotConversationStatusEnum.DISABLED
        case ChatConversationStatus.ENABLED:
          return ChatbotConversationStatusEnum.ENABLED
        default:
          return ChatbotConversationStatusEnum.ENABLED
      }
    }


}
